var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{staticClass:"px-0"},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.label)+":")]),_c('div',{class:[
        _vm.inputClass,
        'text--darken-3 body-2',
        {'grey--text':_vm.inputClass.indexOf('text') === -1}
      ]},[_vm._v(" "+_vm._s(_vm.value)+" "),_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }